import { P5Canvas } from "@p5-wrapper/react";

const CELL_SIZE = 40;
const DISPLACEMENT = 10;
const NOISE_SCALE = 0.03;
const SPEED = 0.001;

function sketch(p5) {
  let cols, rows;
  let time = 0;

  function updateGrid() {
    cols = Math.ceil(p5.width / CELL_SIZE) + 2;
    rows = Math.ceil(p5.height / CELL_SIZE) + 2;
  }

  p5.setup = () => {
    p5.createCanvas(window.innerWidth, window.innerHeight);
    p5.noiseDetail(3, 0.5);
    p5.theme = "dark";
    updateGrid();
  };

  p5.windowResized = () => {
    p5.resizeCanvas(window.innerWidth, window.innerHeight);
    updateGrid();
  };

  p5.updateWithProps = (props) => {
    if (!p5._renderer) return;
    if (props.theme) p5.theme = props.theme;
    if (props.width && props.height) {
      const w = props.width;
      const h = props.height;
      if (w !== p5.width || h !== p5.height) {
        p5.resizeCanvas(w, h);
        updateGrid();
      }
    }
  };

  p5.draw = () => {
    time += SPEED;

    const isDark = p5.theme !== "light";
    p5.background(isDark ? 20 : 242);
    p5.stroke(isDark ? 220 : 88, isDark ? 80 : 110);
    p5.strokeWeight(1.5);
    p5.noFill();

    // Store displaced vertices
    const points = Array.from({ length: rows }, () => new Array(cols));

    for (let j = 0; j < rows; j++) {
      for (let i = 0; i < cols; i++) {
        const baseX = i * CELL_SIZE;
        const baseY = j * CELL_SIZE;

        const angle =
          p5.noise(i * NOISE_SCALE, j * NOISE_SCALE, time) * p5.TWO_PI * 2;

        const dx = Math.cos(angle) * DISPLACEMENT;
        const dy = Math.sin(angle) * DISPLACEMENT;

        points[j][i] = {
          x: baseX + dx,
          y: baseY + dy,
        };
      }
    }

    // Horizontal lines
    for (let j = 0; j < rows; j++) {
      p5.beginShape();
      for (let i = 0; i < cols; i++) {
        p5.vertex(points[j][i].x, points[j][i].y);
      }
      p5.endShape();
    }

    // Vertical lines
    for (let i = 0; i < cols; i++) {
      p5.beginShape();
      for (let j = 0; j < rows; j++) {
        p5.vertex(points[j][i].x, points[j][i].y);
      }
      p5.endShape();
    }
  };
}
export default function Noise({ width, height, theme }) {
  return <P5Canvas sketch={sketch} width={width} height={height} theme={theme} />;
}
